// src/app/services/adpGage.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { ILight, ILightParams, UpdatePayload } from '../models';

export const lightApi = createApi({
  reducerPath: 'lightApi',
  baseQuery,
  endpoints: (builder) => ({
    getLightParams: builder.query<{ light: ILightParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/lights/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getLight: builder.query<ILight, number>({
      query: (id) => `/api/v1.0/ahu/lights/${id}`,
      transformResponse: (data: ILight) => {
        data.lightParams = data.light_params
          ? JSON.parse(data.light_params)
          : {};
        data.switchParams = data.switch_params
          ? JSON.parse(data.switch_params)
          : {};
        return data;
      },
    }),
    getAllLightsCount: builder.query<{ count: number }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/lights/all/count/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getLightsCount: builder.query<{ count: number }, string>({
      query: (queryString) =>
        `/api/v1.0/cms/1/v1.0.0/ahu/lights/all/count/?${queryString}`,
      extraOptions: {
        cacheData: true,
      },
    }),
    getAllSwitchCount: builder.query<{ count: number }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/lights/switches/all/count/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getSwitchCount: builder.query<{ count: number }, string>({
      query: (queryString) =>
        `/api/v1.0/cms/1/v1.0.0/ahu/lights/switches/all/count/?${queryString}`,
      extraOptions: {
        cacheData: true,
      },
    }),
    updateLight: builder.mutation<ILight, UpdatePayload<ILight>>({
      query: ({ id, body, signal }) => ({
        url: `/api/v1.0/ahu/lights/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
      transformResponse: (data: ILight) => {
        data.lightParams = data.light_params
          ? JSON.parse(data.light_params)
          : {};
        data.switchParams = data.switch_params
          ? JSON.parse(data.switch_params)
          : {};
        return data;
      },
    }),
  }),
});

export const {
  useLazyGetLightQuery,
  useGetLightParamsQuery,
  useGetAllLightsCountQuery,
  useLazyGetLightsCountQuery,
  useGetAllSwitchCountQuery,
  useLazyGetSwitchCountQuery,
  useGetLightQuery,
  useUpdateLightMutation,
} = lightApi;
